import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TESTIMONIAL_CONTAINER_CONVERTER_TOKEN, TestimonialContainerConverter } from './testimonial-container.component.converter'
import { TESTIMONIAL_SLIDE_CONVERTER_TOKEN, TestimonialSlideConverter } from './testimonial-slide/testimonial-slide.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        testimonialContainerFeature: {
          module: () => import('./testimonial-container.module').then((m) => m.TestimonialContainerModule),
          cmsComponents: ['testimonial_container'],
        },
      }
    }),
    {
      provide: TESTIMONIAL_CONTAINER_CONVERTER_TOKEN,
      useClass: TestimonialContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        testimonial_container: TESTIMONIAL_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TESTIMONIAL_SLIDE_CONVERTER_TOKEN,
      useClass: TestimonialSlideConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        testimonial: TESTIMONIAL_SLIDE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TestimonialContainerFeatureModule {}
